export const MAX_FILES_UPLOADED = 1;

// TEMPLATE : 'Erreur XXX : MESSAGE'

export const ERROR_FILES_NUMBER = `Vous ne pouvez pas importer plus de ${MAX_FILES_UPLOADED} fichiers.`;
export const ERROR_FILES_TYPE =
  "Le type de fichier ne correspond pas. Vous ne pouvez importer que des .csv, des .xls ou des .xlsx.";
export const ERROR_UPLOAD = "Une erreur est survenue.";
export const ERROR_ALLREADY_UPLOADED = "Votre fichier existe déjà avec le même nom"
